import PropTypes from "prop-types";
import React from "react";
import LeadLink from "web/react/components/lead-link/lead-link";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./product-description-express-checkout-disclaimer.css";

function ProductDescriptionExpressCheckoutDisclaimer({ retailerName, leadUrl, productId }) {
    return (
        <div className={styles.express_checkout_disclaimer}>
            <div className={styles.or}>{gettext("in_stock_product.or_separator")}</div>
            <LeadLink
                href={leadUrl}
                productId={productId}
                openInNewTab={true}
                reason="retailer-ec-disclaimer"
            >
                <p className={styles.disclaimer}>
                    <span className={styles.copy}>
                        {gettext("product.buy_area.size_stock_disclaimer", {})}
                    </span>
                    {retailerName}
                </p>
            </LeadLink>
        </div>
    );
}

export default ProductDescriptionExpressCheckoutDisclaimer;

ProductDescriptionExpressCheckoutDisclaimer.propTypes = {
    retailerName: PropTypes.string.isRequired,
    leadUrl: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
};
